module.exports = __webpack_public_path__ + "img/leotranslate.cab22847.png";